import { ServiceOrderType } from "@/_constants/serviceOrder";
import { IOfferType } from "@/modules/serviceOrdering/interfaces/OfferType";

export enum CustomerType {
  COMPANY = "company",
  INDIVIDUAL = "individual",
}

export interface CustomerAddress {
  address?: string;
  postal_code?: string;
  city?: string;
  country_alpha2?: string;
}

export interface PlanItem {
  label?: string;
  enabled: boolean;
  vat_rate?: string;
  country_alpha2?: string;
  description?: string;
  v2_id?: number;
}

export interface Mandate {
  provider: string;
  source_id: string;
}

export enum InvoiceFrequencyEnum {
  MONTHLY = "monthly",
  PER_ORDER = "per_order",
}

export interface CustomerInvoice {
  id: string;
  service_report_id: string;
  service_type: ServiceOrderType;
}

export interface ICustomer {
  id?: string;
  sourceId?: string;
  offerType?: IOfferType;
  invoices?: CustomerInvoice[];
  invoiceFrequencyEdl?: InvoiceFrequencyEnum;
  invoiceFrequencyErp?: InvoiceFrequencyEnum;
  billingDay?: string;
}
